//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mgSelect from '@/components/custom/mg-select.vue';
import mgInput from '@/components/custom/mg-input.vue';
import { resourseOpts, pluginOpts } from '@/utils/enum';
import { isElectron } from '@/utils/constants';

let ticking = false;

export default {
  components: {
    mgSelect,
    mgInput,
  },
  props: {
    is_tag_search: {
      type: Boolean,
      default: true,
    },
    tag_name: {
      type: String,
      default: '',
    },
    search_key: {
      type: String,
      default: '',
    },
    cata_name: {
      type: String,
      default: '资源',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    initServerData: {
      type: Object,
      default() {
        return {
          total: 0,
          plugin_total: 0,
        };
      },
    },
  },
  data() {
    return {
      catalogs: [
        {
          cata_name: '资源',
          num: '',
        },
        {
          cata_name: '插件',
          num: '',
        },
      ],
      defaultChoosed: 0,
      inputVal: '',
      needSticky: false,
      needFixed: false,
      showInput: false,
      isClient: false,
    };
  },
  watch: {
    cata_name() {
      this.defaultChoosed = 0;
    },
    search_key() {
      this.inputVal = this.search_key;
    },
  },
  computed: {
    filterOptions() {
      return this.cata_name === '资源' ? resourseOpts : pluginOpts;
    },
  },
  methods: {
    changeInput(value) {
      this.inputVal = value;
      if (this.inputTimer) {
        clearTimeout(this.inputTimer);
        this.inputTimer = null;
      }
      if (!value) {
        this.changeKey(value);
        return;
      }
      this.inputTimer = setTimeout(() => {
        this.changeKey(value);
      }, 500);
    },
    changeKey() {
      if (this.inputTimer) {
        clearTimeout(this.inputTimer);
        this.inputTimer = null;
      }
      if (!this.inputVal && this.is_tag_search) return;
      const query = { ...(this.$route.query || {}) };
      if (this.inputVal) {
        query.k = this.inputVal;
      } else {
        delete query.k;
      }
      this.$router.push({
        path: '/search',
        query,
      });
    },
    changeType(cata_name) {
      this.$emit('changeCatalog', cata_name);
    },
    changeFilter() {
      this.$emit('changeFilter', this.defaultChoosed);
    },
    scrollEvent() {
      if (!ticking) {
        window.requestAnimationFrame(this.initData);
        ticking = true;
      }
    },
    initData() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const filterSearch = this.$refs['filter-search'];
      const titleHeight = 100;
      const input = this.$refs['cata-input']?.$refs.input_wrap;
      if (input) {
        window.input = input;
        const position = input.getBoundingClientRect();
        this.showInput = position.y <= Math.ceil(80 - position.height);
      }
      if (filterSearch) {
        const searchHeight = filterSearch.clientHeight || 0;
        if (!this.isMobileSize()) {
          this.needSticky = scrollTop >= searchHeight + titleHeight;
          this.needFixed = scrollTop >= 84;
        } else {
          this.needSticky = scrollTop >= searchHeight + titleHeight ? true : scrollTop < 60 ? false : this.needSticky;
          this.needFixed = false;
        }
      }
      ticking = false;
    },
    isMobileSize() {
      const clientWidth = document.body.clientWidth;
      return clientWidth <= 740;
    },
  },
  created() {
    this.inputVal = this.search_key;
    if (process.server) {
      const ua = this.$ssrContext.req.headers['user-agent'];
      this.isClient = isElectron(ua);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollEvent);
    this.initData();
    this.isClient = isElectron()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollEvent);
  },
};
